import { RxJSCurrentState, useRxJSState } from '../../React/Common/Hooks/useRxJSState'
import { CRMTypesResponse } from '../../NonReact/common/Types/Types'
import { crmTypes$ } from '../../NonReact/common/RxJS/CRMTypesState'

export type CRMTypes = RxJSCurrentState<CRMTypesResponse[]>

export const useCRMTypes = (): CRMTypes => useRxJSState<CRMTypesResponse[]>(crmTypes$)
